var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAuraLogoB = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1080px",
    height: "1080px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF841B;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#141414;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.2,678.1c0.2,36.6,3.6,93.6,6.2,132.3c1.2,17.9,21.8,27.3,36.1,16.4l504.1-381.9 c38.2-28.9,45.7-83.3,16.8-121.5l0,0c-28.9-38.2-83.3-45.7-121.5-16.8L442,621.7C415.1,638.5,416.2,678.1,416.2,678.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455.9,555.4c-10.2,6.3-21.8,14.6-32.5,24.7L455.9,555.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.5,702.2c0,0-7.8-70.5,54.2-124l303.5-227.6c9.3-7,11.8-19.9,5.7-29.8l-36.1-58.8L582.4,78.5l0,0l-5.6-8.5 C550.3,30.5,506,6.3,458.4,5.8C267.6,3.9,304.1,234.2,310,327.4c1,15.6-1.1,36.6-4.2,57.4c-6.2,41.4-16.8,82.1-31,121.5 c-18.3,50.7-39.9,107.5-52.2,128.4c-21.1,35.9-25.1,39.7-56.4,73.3c-18.9,20.3-39.3,32.3-62,45.1c-21.4,12.1-43.7,23.8-62,42.3 c-21.3,21.5-44.7,54.1-39.5,124c3.4,30.2,18.8,61.1,41.7,92.8c26.4,36.3,67.7,58.8,112.6,61.1l12.1,0.6 c50.1,2.5,89.7-20.6,124.2-53.9c30.6-29.5,50.6-64.6,64.1-105.6c8.7-26.3,14.9-53.6,16.2-81.3C374.8,809.3,368.7,738.8,368.5,702.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1055.8,848c0-0.1-0.1-0.2-0.2-0.2l-161-262.8c-7-11.4-22.2-14.2-32.8-6.2L660.9,731 c-9.3,7-11.7,19.9-5.6,29.8l26.5,42.9c0,0,117.9,193.8,121.8,200.2c43,69.7,134.4,91.2,204.1,48.2 C1077.3,1009,1098.9,917.6,1055.8,848z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAuraLogoB);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aura-logo-b.d6ad0f01d85a3679bf7fe67a86cb5425.svg";